module.exports = __webpack_public_path__ + "img/carousel4.7bfdf34e.png";